module.exports = __webpack_public_path__ + "static/media/arrow-up-s-line.dae311ed.svg";